"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconSmallBusinessElectricity = function IconSmallBusinessElectricity(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M22 5v4l-.003 10.005A3.73 3.73 0 0 1 19 22.944V43H9.27a24 24 0 0 1-2.268-2H17V22.937a3.75 3.75 0 0 1-1.71-.84l-.162-.148-.11-.112a3.81 3.81 0 0 1-2.868 1.25l-.139-.007-.134.01a3.74 3.74 0 0 1-2.632-.938l-.163-.154a4 4 0 0 1-.327-.373c-.905.816-2.201 1.321-3.538 1.37L5 23v-2c1.499 0 2.885-.896 2.993-1.877L8 19V8h12V7h-9V5zM10 19.08V10h4v9.08l-.008.207q0 .093.004.187a1.81 1.81 0 0 1-1.926 1.608l-.17.003-.173.009a1.74 1.74 0 0 1-1.73-1.953zm5.998-.067q.015.216.005.43c.037.349.177.68.404.949l.116.124a1.75 1.75 0 0 0 1.214.496l.17-.008.195.001a1.73 1.73 0 0 0 1.382-.481c.326-.318.513-.749.521-1.252L20 19.08V10h-4zM34.08 27.72l3.19-6.37v4.78h1.59l-3.18 6.37v-4.78zm-19.586 4.286-5.07-5.07-.708.707 5.07 5.07zm-8.45-4.21 7.59 7.59-.708.707-7.59-7.59zm4.21 8.45-5.07-5.07-.708.708 5.07 5.07zM42 13H26v19.24A3.76 3.76 0 0 0 29.76 36H42zm-2 21H29.76l-.144-.006A1.76 1.76 0 0 1 28 32.24V15h12zm-6-17v1h-5v-1zm1 3v-1h-6v1z",
    clipRule: "evenodd"
  })));
};

export { IconSmallBusinessElectricity, IconSmallBusinessElectricity as default };
